export default __webpack_public_path__ + "static/media/divergentes-icon.76e5ca69.svg";